import * as React from 'react'
import 'intersection-observer'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { link, linkWrapper } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { ButtonData } from '../../../../wordpress/types_and_parser/extra_types.mod'

export type CtaAttributes = {
  blockName: 'vidda/cta'
  title: string
  intro: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
}

export interface CtaInterface {
  blockName: 'vidda/cta'
  attrs: CtaAttributes
}

export type CtaBlockProps<extra_images> = CtaAttributes

export type CtaBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function CtaBlock<customBlockData, extra_images>(
  props: CtaBlockProps<extra_images>,
  options?: { style?: CtaBlockStyle; key?: string }
): IOWidget<
  CMSState<customBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<customBlockData, extra_images, never>>
> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: (_) => (
        <section className={`block block--cta block--cta-text`}>
          <div className={`block__inner grid--block container--m`}>
            <div className="block__content">
              <header className="block__header">
                {props.title && <h2 className="block__title typo--xl">{props.title}</h2>}
              </header>

              <div className="block__wrap">
                {props.intro && (
                  <div className="text--styled typo--xs" dangerouslySetInnerHTML={{ __html: props.intro }}></div>
                )}
                {(props.primary_button || props.secondary_button) && (
                  <footer className="block__footer">
                    {props.primary_button && (
                      <>
                        {link(
                          linkWrapper({ title: props.primary_button.text, url: props.primary_button.url }),
                          { classname: 'button button--primary--inverted' },
                          props.primary_button.text,
                          () => {
                            window.dataLayer.push({
                              event: 'event.dubbeldam',
                              category: 'CTABlock',
                              action: props.primary_button.text,
                              label: window.location.pathname,
                            })
                          }
                        )}
                      </>
                    )}
                    {props.secondary_button && (
                      <>
                        {link(
                          linkWrapper({ title: props.secondary_button.text, url: props.secondary_button.url }),
                          { classname: 'link link--secondary' },
                          props.secondary_button.text,
                          () => {
                            window.dataLayer.push({
                              event: 'event.dubbeldam',
                              category: 'CTABlock',
                              action: props.secondary_button.text,
                              label: window.location.pathname,
                            })
                          }
                        )}
                      </>
                    )}
                  </footer>
                )}
              </div>
            </div>
          </div>
        </section>
      ),
    })
}
